<template>
	<transition 
			appear
			:appear-active-class="$_expPnlLyt_stylePageLayoutAnimation()">
		<v-row	class="customVRow" 
				align="start"
				no-gutters>
			<v-col>
				<v-expansion-panels>
					<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
						<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
							<v-expansion-panel
									:key="contentKey"

									:color="$_expPnlLyt_styleBannerColor"
									:dark="$_expPnlLyt_styleBannerDark"
									:elevation="$_expPnlLyt_styleBannerElevation"
									:icon-color="$_expPnlLyt_styleBannerIconColor"
									:light="$_expPnlLyt_styleBannerLight"
									:tile="$_expPnlLyt_styleBannerTile">
								<v-expansion-panel-header>
									<span	class="title"
											v-html="$_expPnlLyt_langContentTitle(contentVals)" />
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<template v-if="!isFalse($_expPnlLyt_langContentText(contentVals))">
										<v-row>
											<v-col class="center" cols="auto">
												<span	class="body-2 markdown"
														v-html="marked($_expPnlLyt_langContentText(contentVals))" />
											</v-col>
										</v-row>
									</template>
									<v-row>
										<v-col class="center" cols="auto">
											<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
												<v-row	:key="actionButtonKey" 
														dense>
													<v-col cols="auto">
														<v-btn	class="customVBtn"
																:block="$_expPnlLyt_styleActionButtonBlock"
																:color="$_expPnlLyt_styleActionButtonColor"
																:dark="$_expPnlLyt_styleActionButtonDark"
																:depressed="$_expPnlLyt_styleActionButtonDepressed"
																:elevation="$_expPnlLyt_styleActionButtonElevation"
																:large="$_expPnlLyt_styleActionButtonLarge"
																:light="$_expPnlLyt_styleActionButtonLight"
																:outlined="$_expPnlLyt_styleActionButtonOutlined"
																:rounded="$_expPnlLyt_styleActionButtonRounded"
																:small="$_expPnlLyt_styleActionButtonSmall"
																:text="$_expPnlLyt_styleActionButtonFlat"
																@click="openLink(actionButtonVals.link)"
																v-text="$_expPnlLyt_langActionButtonTitle(actionButtonVals)" />
													</v-col>
												</v-row>
											</template>
										</v-col>
									</v-row>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</template>
					</template>
				</v-expansion-panels>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'ExpansionPanelLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				colors_: {}
			}
		},
		computed: {
			// state
			$_expPnlLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			// lang 
			// (content)
			$_expPnlLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_expPnlLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_expPnlLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// style
			$_expPnlLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_expPnlLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_expPnlLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_expPnlLyt_styleBanner() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'banner')
			},
			$_expPnlLyt_styleBannerColor() {
				const self_ = this;
				const banner_ = self_.$_expPnlLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.color)
			},
			$_expPnlLyt_styleBannerDark() {
				const self_ = this;
				const banner_ = self_.$_expPnlLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.dark)
			},
			$_expPnlLyt_styleBannerElevation() {
				const self_ = this;
				const banner_ = self_.$_expPnlLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.elevation)
			},
			$_expPnlLyt_styleBannerFlat() {
				const self_ = this;
				const banner_ = self_.$_expPnlLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.flat)
			},
			$_expPnlLyt_styleBannerHover() {
				const self_ = this;
				const banner_ = self_.$_expPnlLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.hover)
			},
			$_expPnlLyt_styleBannerIconColor() {
				const self_ = this;
				const banner_ = self_.$_expPnlLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.iconColor)
			},
			$_expPnlLyt_styleBannerLight() {
				const self_ = this;
				const banner_ = self_.$_expPnlLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.light)
			},
			$_expPnlLyt_styleBannerOutlined() {
				const self_ = this;
				const banner_ = self_.$_expPnlLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.outlined)
			},
			$_expPnlLyt_styleBannerRaised() {
				const self_ = this;
				const banner_ = self_.$_expPnlLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.raised)
			},
			$_expPnlLyt_styleBannerTile() {
				const self_ = this;
				const banner_ = self_.$_expPnlLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.tile)
			},
			$_expPnlLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'actionButton')
			},
			$_expPnlLyt_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_expPnlLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_expPnlLyt_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_expPnlLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_expPnlLyt_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_expPnlLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_expPnlLyt_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_expPnlLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_expPnlLyt_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_expPnlLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_expPnlLyt_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_expPnlLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_expPnlLyt_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_expPnlLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_expPnlLyt_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_expPnlLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_expPnlLyt_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_expPnlLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_expPnlLyt_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_expPnlLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_expPnlLyt_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_expPnlLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			}
		},
		methods: {
			$_expPnlLyt_getChanceColor(key) {
				const self_ = this;

				if(self_.colors_[key]) { return self_.colors_[key] }

				self_.colors_[key] = self_.getChanceColor()
				return self_.colors_[key]
			}
		}
	}
</script>

<style scoped>
	.cardActions_ {
		padding-bottom: 16px;
	}
</style>
